import Vue from 'vue'
import App from './App.vue'
import 'vuetify/dist/vuetify.min.css'
import VueRouter from 'vue-router'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import './assets/custom.scss'

//Vue.use(Vuetify)
Vue.use(VueRouter);

//const vuetify = new Vuetify({  })
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons )

const router = new VueRouter({})

new Vue({
  el: '#wp-vue-app',
  router: router,
//  vuetify: vuetify,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js